import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AppSettings } from '../../common/app.settings';
import { ErrorHandler } from '../../common/errorHandler';
import { VoteLocationService } from '../../services/vote.location.service';
import { VoteLocation } from '../../models/vote.location.model';
import { ResultCode } from '../../enums/resultcode.enum';
import { FileImportModel } from '../../models/file.import.model';
import { Party } from '../../enums/party.enum';

@Component({
    selector: 'vote-location-detail',
    templateUrl: './vote-location-detail.component.html',
    styleUrls: ['./vote-location-detail.component.css'],
    providers: [VoteLocationService, ErrorHandler, FormBuilder]
})
export class VoteLocationDetailComponent implements OnInit {
    voteLocation: VoteLocation;
    isDataAvailable = false;
    form: FormGroup;
    messages: Array<string>;
    private userId: string;
    keys: any[];
    parties = Party;
    party: Party;
    selectedParty: number;

    constructor(
        private voteLocationService: VoteLocationService,
        private errorHandler: ErrorHandler,
        private router: Router,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder
    ) {
        this.voteLocation = new VoteLocation();
        this.keys = Object.keys(this.parties).filter(Number);
        this.party = Party.unbekannt; //Default the value
        this.selectedParty = 0;
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
                    if (params['voteLocationId'] && params['voteLocationId'] !== '0') {
                        this.voteLocationService.get(params['voteLocationId'])
                            .then(voteLocation => {
                                this.voteLocation = voteLocation;
                                this.selectedParty = parseInt(voteLocation.lastVoteParty);
                                this.isDataAvailable = true;
                            }
                        )
                        .catch(error => {
                            this.errorHandler.do(error);
                        });
                    } else {
                        this.isDataAvailable = true;
                    }
        });
    }

    save(): void {
        if (this.voteLocation.id === undefined) {
            this.insert();
        } else {
            this.update();
        }
    }

    private update(): void {
        this.isDataAvailable = false;
        this.voteLocation.lastVoteParty = this.selectedParty.toString();
        this.voteLocationService.update(this.voteLocation)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['voteLocations']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private insert(): void {
        this.isDataAvailable = false;
        this.voteLocation.lastVoteParty = this.selectedParty.toString();
        this.voteLocationService.add(this.voteLocation)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['voteLocations']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    cancel(): void {
        this.router.navigate(['voteLocations']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/votelocation-detail/vote-location-detail.component.ts